import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function SocialProof() {
  // Generate some random pastel colors for avatars
  const avatarColors = ['bg-pastel-lavender', 'bg-pastel-aqua', 'bg-pastel-mint', 'bg-pastel-yellow', 'bg-pastel-pink'];
  return <section className="py-6 bg-white border-y border-gray-100" data-id="element-272">
      <div className="container mx-auto px-5" data-id="element-273">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center" data-id="element-274">
          <div className="flex -space-x-3" data-id="element-275">
            {[1, 2, 3, 4, 5].map((i, index) => <div key={i} className={`w-10 h-10 rounded-full border-2 border-white flex items-center justify-center text-white font-bold text-sm ${avatarColors[index]}`} data-id="element-276">
                {String.fromCharCode(64 + i)}
              </div>)}
          </div>

          <div className="flex flex-col items-center sm:items-start" data-id="element-277">
            <div className="flex gap-1 text-pastel-yellow mb-1" data-id="element-278">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} size={16} fill="currentColor" data-id="element-279" />)}
            </div>
            <p className="text-sm font-bold text-gray-700" data-id="element-280">
              +500 familias argentinas{' '}
              <span className="font-normal text-gray-500" data-id="element-281">
                ya lo están usando
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}